import { inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { ResolveFn } from '@angular/router';
import { environment } from '../../../environments/environment';

/**
 * Backward-compatibility entry point for legacy FormGenerator MVC secure-upload download links:
 *   `/SecureUpload/Download/{submissionId}`      -> data.kind = 'download'
 *   `/SecureUpload/DownloadFiles/{submissionId}` -> data.kind = 'downloadfiles'
 * These historically lived on the old DNS (now the SPA). We forward the browser to the matching
 * backend endpoint (a cross-origin API URL), which owns the actual download / redirect behavior.
 *
 * The target is an external URL, so it can't be expressed as an Angular RedirectCommand; the
 * resolver performs the `window.location.href` navigation directly and resolves nothing. It runs
 * as a route resolver on a component-less route so no component renders.
 */
export const legacyDownloadRedirectResolver: ResolveFn<void> = route => {
  if (!isPlatformBrowser(inject(PLATFORM_ID))) {
    return;
  }

  const submissionId = route.paramMap.get('submissionId');
  const kind = route.data['kind'] as 'download' | 'downloadfiles';
  if (!submissionId || !kind) {
    return;
  }

  window.location.href = `${environment.apiBaseUrl}/api/secureupload/${kind}/${submissionId}`;
};
